<div class="stepper-body">
    <div class="body-title">
        <span>You’re almost there, {{firstName}}!</span>
    </div>
    <div *ngIf="isLoadingSubmit" class="loading-container">
        <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
    </div>
    <div *ngIf="!isLoadingSubmit" class="body-description">
        <span>What is the best phone number to get in touch with you?</span>
    </div>
    <div *ngIf="!isLoadingSubmit" class="body-answers custom-answers">
        <div class="custom-container">
            <form [formGroup]="formGroup">
                <div class="input-container">
                    <mat-form-field appearance="outline" class="step-input">
                        <mat-label>{{ ConfirmationInputs.Phone }}</mat-label>
                        <input matInput [formControlName]="ConfirmationInputs.Phone" [required]="true" />
                        <mat-error *ngIf="formGroup.get(ConfirmationInputs.Phone)?.touched
                                        && formGroup.get(ConfirmationInputs.Phone)?.hasError('required')">
                            {{ ConfirmationInputs.Phone }} is required
                        </mat-error>
                        <mat-error *ngIf="formGroup.get(ConfirmationInputs.Phone)?.touched
                                        && formGroup.get(ConfirmationInputs.Phone)?.hasError('pattern')">
                            {{ ConfirmationInputs.Phone }} format is incorrect
                        </mat-error>
                        <mat-error *ngIf="formGroup.get(ConfirmationInputs.Phone)?.touched
                                        && formGroup.get(ConfirmationInputs.Phone)?.hasError('internationalPhone')">
                            {{ ConfirmationInputs.Phone }} is not a valid phone number
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="checkbox-group">
                    <div class="checkbox-container-custom">
                        <mat-checkbox [formControlName]="businessCheckbox.title" [checked]="false" [required]="true"
                            [aria-label]="businessCheckbox.label"> </mat-checkbox>

                        <div class="checkbox-label-container">
                            <span class="checkbox-main-label">{{ businessCheckbox.label }}</span>

                            <a href="javascript:void(0);"
                                (click)="$event.preventDefault(); openViewTermsModal(businessCheckbox.link.key)"
                                class="checkbox-terms-link">
                                {{ businessCheckbox.link.label }} </a>
                        </div>
                    </div>
                    <div class="checkbox-container-custom">
                        <mat-checkbox [formControlName]="messageCheckbox.title" [checked]="false" [required]="true"
                            [aria-label]="messageCheckbox.label"> </mat-checkbox>

                        <div class="checkbox-label-container">
                            <span class="checkbox-main-label">{{ messageCheckbox.label }}</span>

                            <a href="javascript:void(0);"
                                (click)="$event.preventDefault(); openViewTermsModal(messageCheckbox.link.key)"
                                class="checkbox-terms-link">
                                {{ messageCheckbox.link.label }} </a>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <div *ngIf="!isLoadingSubmit">
        <div class="footer-text-container">
            <span >By clicking Submit, you consent to </span>
            <a href="https://rfm.io/legal/" target="_blank" rel="noopener noreferrer">
                Realfinity’s Terms of Use
            </a>
            <span > and </span>
            <a href="https://rfm.io/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">
                Privacy Policy.
            </a>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary" (click)="onBack()" class="step-button secondary" [disabled]="isLoadingSubmit">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary"
            [disabled]="isNextDisabled()">
            Submit
        </button>
    </div>
</div>